import { createContext } from 'react';

import {
  TicketAssignment,
  TicketAssignmentTestRequest,
  TicketAssignmentTestResult,
} from '@totem/components/ticketing/assignments/types';
import {
  CategorizationNode,
  OrganizationReference,
} from '@totem/components/ticketing/categorizationManagement/types';

interface Context {
  loading: boolean;
  assignments: TicketAssignment[];
  // Ticket Type -> Category -> SubCategory tree, for the match pickers
  categorization: CategorizationNode[];
  organizations: OrganizationReference[];
  canEdit: boolean;

  editingAssignment: TicketAssignment | null;
  drawerOpen: boolean;
  saving: boolean;
  onAdd: () => void;
  onEdit: (assignment: TicketAssignment) => void;
  onDuplicate: (assignment: TicketAssignment) => void;
  onDrawerClose: () => void;
  onSave: (assignment: TicketAssignment) => void;
  onDelete: (id: string) => void;

  testOpen: boolean;
  onTestOpen: () => void;
  onTestClose: () => void;
  runTest: (
    request: TicketAssignmentTestRequest,
  ) => Promise<TicketAssignmentTestResult[]>;
}

export default createContext<Context>({
  loading: false,
  assignments: [],
  categorization: [],
  organizations: [],
  canEdit: false,

  editingAssignment: null,
  drawerOpen: false,
  saving: false,
  onAdd: () => {},
  onEdit: () => {},
  onDuplicate: () => {},
  onDrawerClose: () => {},
  onSave: () => {},
  onDelete: () => {},

  testOpen: false,
  onTestOpen: () => {},
  onTestClose: () => {},
  runTest: () => Promise.resolve([]),
});
